import {DonationComponent} from "../donation/donation.component";
import {ChangeDetectorRef, Component, Renderer2} from "@angular/core";
import {OptionService} from "../option/option.service";
import {DonationService} from "../donation/donation.service";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Donation} from "../donation/donation";
import {UrlService} from "../url/url.service";
import {HttpClient} from "@angular/common/http";
import {DecimalPipe} from "@angular/common";
import {AmountComponent} from "../amount/amount.component";
import {ElementService} from "../service/element.service";
import {StripeService} from "../payment/payment.stripe.service";

@Component({
    selector: 'donation-app',
    templateUrl: './custom.ti.component.html',
    providers: [OptionService, DonationService, UrlService, DecimalPipe]
})
export class CustomTiComponent extends DonationComponent {

    /**
     * Holds the contributionValue
     */
    contributionValue: string = 'normal';

    /**
     * @see super()
     * @param {OptionService} optionService
     * @param {TranslateService} translate
     * @param {DonationService} donationService
     * @param {HttpClient} http
     * @param {ChangeDetectorRef} changeDetector
     * @param {UrlService} urlService
     * @param {Renderer2} renderer
     * @param decimalPipe
     * @param elementService
     * @param stripeService
     */
    constructor(protected optionService: OptionService,
                protected translate: TranslateService,
                protected donationService: DonationService,
                protected http: HttpClient,
                protected changeDetector: ChangeDetectorRef,
                protected urlService: UrlService,
                protected renderer: Renderer2,
                protected decimalPipe: DecimalPipe,
                protected elementService: ElementService,
                protected stripeService: StripeService) {
        super(optionService, translate, donationService, http, changeDetector, urlService, renderer, decimalPipe, elementService, stripeService);

        // set default start step
        this.step = "contribution";
        // for dev purpose: start on personal-data
        // this.step = "personal-data";

        // set transaction type
        this.donation.transactionType = Donation.TRANSACTION_TYPE_MEMBERSHIP;
        this.donation.amount = 120;

        // preset first payment method
        let paymentMethods = this.optionService.getPaymentMethods();
        if(paymentMethods.length > 0) {
            this.donation.paymentMethod = paymentMethods[0];
        }

    }

    /**
     * is called when a input form is submitted (it is valid in this case)
     */
    submitForm(): void {
        let form:FormGroup;

        // Define which form has to be validatet, depending on the step
        if(this.step == "personal-data") {
            form = this.contactForm;
        }
        else if(this.step == "contribution") {
            form = this.widgetStartForm;
        }
        else {
            form = this.widgetPaymentForm;
        }


        if(form.valid == false) {
            console.warn("Form is NOT valid", form);
            // Set all controls as touched to show the error messages
            for(let name in form.controls) {
                (<FormControl>form.controls[name]).markAsTouched({onlySelf: true});
            }
            return;
        }

        switch(this.step) {
            case "personal-data":
                this.setStep("payment");
                break;
            case "contribution":
                this.setStep("personal-data");
                break;
            case "payment":
                this.startDonation();
                break;
            default:
                console.debug("Implement this (submit form after donation on widget)!");
        }
    }

    /**
     * Move one step back
     *
     */
    stepBack(): void {
        switch(this.step) {
            case "contribution":
                // do nothing
                break;
            case "personal-data":
                this.setStep("contribution");
                break;
            case "payment":
                this.setStep("personal-data");
                break;
            default:
                console.debug("Implement this (submit form after donation on widget)!");
        }
    }

    /**
     * @inheritDoc
     * @param newStep
     * @param scroll
     */
    setStep(newStep: string, scroll: boolean = false): void {
        if(newStep === 'start') {
            // in some cases (payment canceled or has error) there is a redirect made to the start step. We do not have the start step here.
            newStep = 'payment';
        }
        super.setStep(newStep, scroll);
    }

    /**
     * Set the amount if the user switches the amount buttons.
     * @param amount
     */
    setAmount(amount: number): void {
        // change th also in the form, if it was initialized already (only if user activates the slider at least once)
        this.widgetStartForm.get('amount')?.setValue(amount);
        this.widgetStartForm.get('amount')?.setValidators([Validators.min(amount), Validators.max(AmountComponent.SLIDER_END_GENERAL)]);

        // set the amount on the donation
        this.donation.amount = amount;
    }
}
